module.exports = __webpack_public_path__ + "static/media/search.903d76af.svg";